import React, { useState, useMemo, useEffect } from "react";
import { Table as BootstrapTable } from "react-bootstrap";
import accepted from "../../assets/images/accepted.png";
import cancelled from "../../assets/images/cancelled.png";
import exit from "../../assets/images/exit.png";
import pending from "../../assets/images/pending.png";
import rejected from "../../assets/images/rejected.png";
import ReleasedAndCanceled from "../../assets/images/ReleasedAndCanceled.png";
import blocked from "../../assets/images/blocked.png";
import TranslateFile from "../../config/TranslateFile";

const FindInmatesTableNew = ({
  columns = [],
  data = [],
  showSearch = true,
  rowsPerPage = 10,
  rowsPerPageOptions = [5, 10, 15, 20],
  page = 1,
  onPageChange,
  onRowsPerPageChange
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(rowsPerPage);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });
  const currentLang = TranslateFile();


  const ActionIcons = {
    AddToContacts: {
      className: "fa fa-user-plus",
      title: currentLang?.buttons?.AddToContacts,
    },
  };

  // Filtered data based on search term
  const filteredData = useMemo(() => {
    if (!searchTerm) return data;

    return data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, data]);


  useEffect(() => {
    setCurrentPage(page);
  }, [page]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    onPageChange?.(newPage); // <-- update parent state
  };

  // Total pages
  const totalPages = Math.ceil(filteredData.length / selectedRowsPerPage);

  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  //   alert("hi")
  // };

  const handleRowsPerPageChange = (e) => {
    const rows = parseInt(e?.target?.value, 10);
    onRowsPerPageChange?.(rows);
    setSelectedRowsPerPage(rows);
    setCurrentPage(1); // Reset to the first page
  };

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;

    const sorted = [...filteredData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Optional: if numeric, parse
      if (!isNaN(aValue) && !isNaN(bValue)) {
        aValue = parseFloat(aValue);
        bValue = parseFloat(bValue);
      } else {
        aValue = aValue?.toString().toLowerCase() ?? "";
        bValue = bValue?.toString().toLowerCase() ?? "";
      }

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1;
      return 0;
    });


    return sorted;
  }, [filteredData, sortConfig]);

  // Paginated data
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * selectedRowsPerPage;
    const endIndex = startIndex + selectedRowsPerPage;
    return sortedData.slice(startIndex, endIndex);
  }, [currentPage, sortedData, selectedRowsPerPage]);


  const handleSort = (key) => {
    setSortConfig(prev => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "ascending" ? "descending" : "ascending",
        };
      }
      return { key, direction: "ascending" };
    });
  };




  return (
    <div>
      {/* {showSearch && (
        <div className="input-group mb-3">
          <span className="input-group-text">
            <i className="fa fa-search"></i>
          </span>
          <input
            type="text"
            className="form-control"
            placeholder={currentLang?.Mycontacts?.Search}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      )} */}

      <div className="d-flex justify-content-end">
        <div className="icon-legend">
          <ul className="list-unstyled">
            <li className="d-flex align-items-center mb-2 me-2">
              <i
                className={ActionIcons.AddToContacts.className}
                style={{ marginRight: "8px" }}
              ></i>
              <span>{ActionIcons.AddToContacts.title}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="table-responsive">
        <BootstrapTable className="table table-striped align-middle">
          <thead>
            <tr style={{ background: "#c8605e", color: "#fff" }}>
              {columns.map((col, index) => (
                // <th
                //   key={index}
                //   style={{
                //     padding: "10px",
                //     textAlign: "left",
                //     color: "#fff",
                //   }}
                // >
                //   {col.name}
                // </th>
                <th
                  key={index}
                  onClick={() => handleSort(col.accessor || col.name)}
                  style={{
                    padding: "10px",
                    textAlign: "left",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  {col.name}
                  {sortConfig.key === (col.accessor || col.name) && (
                    <i
                      className={`ms-2 fa ${sortConfig.direction === "ascending"
                        ? "fa-sort-up"
                        : "fa-sort-down"
                        }`}
                    ></i>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.length === 0 ? (
              <div
                className="alert-light-red mb-3 font-size-16 p-3 text-center mt-1"
                style={{ width: "359%" }}
              >
                {currentLang?.info?.NoResult}
              </div>
            ) : (
              paginatedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td
                      key={colIndex}
                      style={{
                        textAlign:
                          col.name === "Status"
                            ? "left"
                            : col.name === "Action"
                              ? "left"
                              : "left",
                        verticalAlign: "middle",
                      }}
                    >
                      {col.name === "Action" ? (
                        <div
                          style={{ display: "flex", justifyContent: "left" }}
                        >
                          {typeof col.cell === "function" && col.cell(row)}
                        </div>
                      ) : typeof col.cell === "function" ? (
                        col.cell(row)
                      ) : typeof col.selector === "function" ? (
                        col.selector(row)
                      ) : (
                        row[col.accessor || col.name]
                      )}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </BootstrapTable>
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-end align-items-center flex-wrap mt-3">
        {/* Pagination Controls */}
        <div className="d-flex align-items-center">
          <span>Rows per page:</span>
          <select
            className="form-select ms-2"
            style={{
              width: "70px",
              height: "36px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              paddingLeft: "8px",
            }}
            value={selectedRowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div className="d-flex align-items-center ms-3">
          <span style={{ marginRight: "16px" }}>
            {filteredData.length > 0
              ? `${(currentPage - 1) * selectedRowsPerPage + 1} - ${Math.min(
                currentPage * selectedRowsPerPage,
                filteredData.length
              )} of ${filteredData.length}`
              : "0 results"}
          </span>
          <button
            className="btn"
            style={{
              color: currentPage === 1 ? "#d3d3d3" : "#000",
              fontSize: "16px",
              border: "none",
              background: "transparent",
              padding: "0 8px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
            disabled={currentPage === 1}
            onClick={() => handlePageChange(1)}
          >
            &#124;&lt;
          </button>
          <button
            className="btn"
            style={{
              color: currentPage === 1 ? "#d3d3d3" : "#000",
              fontSize: "16px",
              border: "none",
              background: "transparent",
              padding: "0 8px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>
          <button
            className="btn"
            style={{
              color: currentPage === totalPages ? "#d3d3d3" : "#000",
              fontSize: "16px",
              border: "none",
              background: "transparent",
              padding: "0 8px",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
          <button
            className="btn"
            style={{
              color: currentPage === totalPages ? "#d3d3d3" : "#000",
              fontSize: "16px",
              border: "none",
              background: "transparent",
              padding: "0 8px",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            &gt;&#124;
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FindInmatesTableNew);
